import React, { useEffect, useState } from 'react';

import Skeleton from 'react-loading-skeleton';
import classNames from 'classnames/bind';
import style from './styles.module.scss';

const cx = classNames.bind(style);

const ResizedImg = ({ defaultSrc, resizedSrc, alt, style, onLoad, onClick }) => {
  const [src, setSrc] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setSrc(resizedSrc || defaultSrc);
  }, []);

  return (
    <div className={cx('ResizedImg')} onClick={onClick}>
      {loading && <Skeleton style={{ width: '100%', height: '100%' }} />}
      <img
        style={style}
        src={src}
        alt={alt}
        style={{ display: loading ? 'none' : 'block' }}
        onLoad={() => setLoading(false)}
        onError={() => (defaultSrc !== src ? setSrc(defaultSrc) : null)}
      />
    </div>
  );
};

export default ResizedImg;
